/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Action_LabelInputs */



/**
* | output |
* | --- |
* | "Import Markers" |
*
* @param {Marker_Import_Action_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_action_label = /** @type {((inputs?: Marker_Import_Action_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Action_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer les marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importmarkierungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импортные марки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcadores de importación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーをインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात मार्कर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marcadores de Importação")
	return /** @type {LocalizedString} */ ("Import Markers")
});